import React from "react";

import { ClientDashboard } from "@/routes/lazyFeatures";

export const ClientDashboardRoute: React.FC = () => <ClientDashboard />;
